import { getIdToken } from "firebase/auth";
import { auth } from "../config/firebase.config";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const makePost = async (url, data, headers = {}) => {
  const token = auth.currentUser ? await getIdToken(auth.currentUser) : "";
  return fetch(`${BASE_URL}${url}`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
      ...headers,
    },
  });
};

export const makeGet = async (url, headers = {}) => {
  const token = auth.currentUser ? await getIdToken(auth.currentUser) : "";
  return fetch(`${BASE_URL}${url}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
      ...headers,
    },
  });
};

// pass -ve value to deduct credits and +ve value to add credits
export const updateEnterpriseCredits = async (data) => {
  const url = `/admin/credits/add`;
  return makePost(url, data);
};
